import { z } from 'zod';

import type { IdAccountDto } from '@/services/ws-creatives/src/main/resources/rest-api';

export enum CreativeFormSearchKey {
  ACCOUNT_ID = 'accountId',
}

/** Account a new creative starts with, carried over from the account filter of the creatives list. */
export const creativeFormRouterSearchParamsSchema = z.object({
  [CreativeFormSearchKey.ACCOUNT_ID]: z.custom<IdAccountDto>().optional(),
});

export type CreativeFormSearchParams = z.infer<typeof creativeFormRouterSearchParamsSchema>;
